import { useLocation } from "react-router-dom";
import Logo from "@/components/Logo";
import { SIMULATOR_URL } from "@/components/Nav";

export default function Footer() {
  const { pathname } = useLocation();
  const onTutorial = pathname.startsWith("/tutorial");
  return (
    <footer className="border-t border-white/10 py-16" data-testid="footer">
      <div className="container-x">
        <div className="flex flex-col justify-between gap-12 md:flex-row md:items-start">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm font-light text-zinc-500">
              Compute at the speed of light.
            </p>
          </div>
          <div className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.25em]">
            <a href="/" data-testid="footer-home-link" className="text-zinc-400 transition-colors hover:text-white">
              Home
            </a>
            <a href="/tutorial" data-testid="footer-tutorial-link" className="text-zinc-400 transition-colors hover:text-white">
              Tutorial
            </a>
            <a
              href={SIMULATOR_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-simulator-link"
              className="text-zinc-400 transition-colors hover:text-beam"
            >
              simulator.qpilabs.com ↗
            </a>
            <a
              href="/privacy"
              data-testid="footer-privacy-link"
              className="text-zinc-400 transition-colors hover:text-white"
            >
              Privacy
            </a>
            <a
              href="/terms"
              data-testid="footer-terms-link"
              className="text-zinc-400 transition-colors hover:text-white"
            >
              Terms
            </a>
            {onTutorial && (
              <a
                href="mailto:info@qpilabs.ai"
                data-testid="footer-email-link"
                className="text-beam transition-colors hover:opacity-80"
              >
                info@qpilabs.ai
              </a>
            )}
          </div>
        </div>
        <div className="mt-16 border-t border-white/10 pt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600">
          <div className="flex flex-col justify-between gap-4 md:flex-row">
            <span>© 2026 QPI Laboratories, Inc. — All rights reserved.</span>
            <span>Photonic AI Accelerators — in simulation</span>
          </div>
          <p className="mt-4 font-sans text-sm normal-case tracking-normal text-zinc-500">
            For research, partnership, or investor inquiries,{" "}
            <a href="mailto:info@qpilabs.ai" data-testid="footer-contact-link" className="font-mono text-beam transition-colors hover:underline">
              please contact us
            </a>.
          </p>
        </div>
      </div>
    </footer>
  );
}
